export enum ScanCenterFeatureEnum {
  ASSIGNMENT_CAPABILITY = "assignment_capability",
}
